'use strict'

// poyfills
import 'core-js/es6/symbol'
import 'core-js/es6/object'
import 'core-js/es6/function'
import 'core-js/es6/parse-int'
import 'core-js/es6/parse-float'
import 'core-js/es6/number'
import 'core-js/es6/math'
import 'core-js/es6/string'
import 'core-js/es6/date'
import 'core-js/es6/array'
import 'core-js/es6/regexp'
import 'core-js/es6/map'
import 'core-js/es6/set'
import 'core-js/es6/set'

import 'core-js/es7/promise.js'


// libs
import $          from 'jquery'
import GMaps      from 'gmaps'
import Sugar      from 'sugar'
import MarkdownIt from 'markdown-it'
// import cheerio    from 'cheerio'
import moment     from 'moment'
import axios      from 'axios'
import _          from 'lodash'

window.$          = $
window.jQuery     = $
window.GMaps      = GMaps
window.Sugar      = Sugar
window.MarkdownIt = MarkdownIt
// window.cheerio    = cheerio
window.moment     = moment
window.axios      = axios
window._          = _
// window.Lazy = Lazy

Sugar.extend()

import 'lib/jquery-ua.custom'
import 'lib/markerclusterer'
import 'jquery-ui/ui/widgets/datepicker'
import 'lib/jquery-ui.datepicker-ja'

// require('fancybox')($)

import purl from 'lib/purl'
$.url = purl



//////////////////
// WEBPACK FOOTER
// ./_src/js/vendor.js
// module id = 445
// module chunks = 0